export const CATEGORY_BULK_CHUNK_SIZE = 8;

export function chunkTargets<T>(targets: readonly T[], size = CATEGORY_BULK_CHUNK_SIZE): T[][] {
  if (!Number.isInteger(size) || size < 1) throw new Error("Kích thước nhóm không hợp lệ");
  const chunks: T[][] = [];
  for (let index = 0; index < targets.length; index += size) chunks.push(targets.slice(index, index + size));
  return chunks;
}

/** Return known outcomes in the original logical target order. */
export function mergeTargetResults<T extends { item_id: string }, R extends { item_id: string }>(
  targets: readonly T[],
  outcomes: ReadonlyMap<string, R>,
): R[] {
  return targets.flatMap((target) => {
    const outcome = outcomes.get(target.item_id);
    return outcome ? [outcome] : [];
  });
}
